var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.common)?_c('navbar'):_vm._e(),(!_vm.common)?_c('navbarCommon'):_vm._e(),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('myfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }